import React from "react";
import { motion } from "framer-motion";
import "./About.scss";

const scaleVariants = {
  whileInView: {
    scale: [0, 1],
    opacity: [0, 1],
    transition: {
      duration: 1,
      ease: "easeInOut",
    },
  },
};

const About = () => {
  return (
    <div className="about__container" id="about">
      <div className="about__text-wrapper">
        <div className="text__wrapper">
          <motion.div
            whileInView={{ x: [-100, 0], opacity: [0, 1] }}
            transition={{ duration: 0.5 }}
            className="headline__container"
          >
            <p className="headline__text">About</p>
          </motion.div>
          <div></div>
        </div>
        <div className="text__container">
          <motion.div
            whileInView={{ x: [-100, 0], opacity: [0, 1] }}
            transition={{ duration: 0.5 }}
            className="text"
          >
            <p>
              Hi. I'm self-taught Frontend developer, nice to meet you. Thank
              You for visiting my portfolio website.
            </p>
          </motion.div>
          <motion.div
            variants={scaleVariants}
            whileInView={scaleVariants.whileInView}
          >
            <p>
              I graduated with a degree in Economics, but right after I started
              learning programming, which shortly became my passion. During that
              period of learning and working on different projects I have
              created many of them, which helped me sharpen my programming
              skills a lot. I am an open-minded guy who's willing to keep on
              working hard and also improving current skills by collaborating
              with other more experienced colleagues. Also, I have created a
              WordPress project, which is made for commercial use by small,
              familly business named{" "}
              <a
                href="https://www.sobinlinekennel.com/"
                target="_blank"
                rel="noreferrer"
              >
                Sobinline Kennel
              </a>
              , which you can visit by clicking on it's name.
            </p>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default About;
